module.exports = __webpack_public_path__ + "img/21.2ce46bad.png";